import { useRef } from 'react'
import { useStats } from '../../lib/ctx/stats'
import { StatsContainer } from '../StatsContainer'
import { StatsHeader } from '../stats_header/StatsHeader'
import { useInView } from 'framer-motion'
import { GenreStatsContent } from './GenreStatsContent'
import { ReaderInsight } from '../shared'
import { GenresShareButton } from './GenresShareButton'
import { useStatsPermission, useStatsZeroState } from '../../lib/hooks'
import { css } from '@fable/theme'
import { StatsHeaderTitle } from '../stats_header'

export const GenreStats = () => {
  const [theme, stats, yearStatus, year] = useStats((s) => [
    s.theme,
    s.stats,
    s.yearStatus,
    s.year,
  ])
  const ref = useRef(null)
  const inView = useInView(ref, {
    once: true,
    amount: 1,
  })
  const mostReadGenre = stats?.genres?.most_read || ''
  const zeroState = useStatsZeroState('genres')
  const { isStatsOwner } = useStatsPermission()

  const getContent = () => {
    if (zeroState && isStatsOwner) {
      if (yearStatus !== 'current') return null

      return (
        <ReaderInsight
          data-testid="reader-insight-genres"
          label="How to get started"
          text="Add books to your Finished list, and make sure to mark that you
        finished it this year. We’ll take it from there!"
        />
      )
    }

    return !zeroState ? (
      <GenreStatsContent data-testid="stats-genres-content" inView={inView} />
    ) : null
  }

  return (
    <StatsContainer
      id="genres"
      ref={ref}
      data-testid="stats-genres"
      backgroundColor={theme.bg100}
      empty={zeroState}
    >
      <StatsHeader actions={zeroState ? null : <GenresShareButton />}>
        <StatsHeaderTitle
          top="Most read genres"
          middle={!zeroState ? mostReadGenre : 'None'}
          bottom={
            !zeroState ? (
              <span
                className={css`
                  opacity: 0.5;
                `}
              >
                {yearStatus === 'past' ? `in ${year}` : 'so far this year'}
              </span>
            ) : (
              'yet...'
            )
          }
          infoButton={{
            text: 'Add books to your Finished list, and make sure to mark that you finished it this year. We’ll take it from there!',
          }}
        />
      </StatsHeader>
      {getContent()}
    </StatsContainer>
  )
}
